import React, { useState } from "react";
import "../../Styles/signup.css";
import { Link, useNavigate } from "react-router-dom";

const SignUpForm = () => {
    const [formdata, setFormData] = useState({
        fullName: "",
        email: "",
        mobile: "",
        password: ""
    });
    const [loading, setLoading] = useState(false);
    const [verificationSent, setVerificationSent] = useState(false);
    const navigate = useNavigate();
    
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const URL = `${API_URL}/api/auth/register`;

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === "mobile") {
            // Only allow numbers and limit to 10 digits
            if (/^\d{0,10}$/.test(value)) {
                setFormData({ ...formdata, [name]: value });
            }
        } else {
            setFormData({ ...formdata, [name]: value });
        }
    };

    const validateForm = () => {
        // Basic validation
        if (!formdata.fullName.trim()) {
            alert("Please enter your full name");
            return false;
        }
        
        if (!formdata.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formdata.email)) {
            alert("Please enter a valid email address");
            return false;
        }
        
        if (!formdata.mobile || formdata.mobile.length !== 10) {
            alert("Please enter a valid 10-digit mobile number");
            return false;
        }
        
        if (!formdata.password || formdata.password.length < 6) {
            alert("Password must be at least 6 characters long");
            return false;
        }
        
        return true;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        
        try {
            setLoading(true);
            console.log('Making registration request to:', URL);
            console.log('Request payload:', { ...formdata, password: '***' });
            
            const res = await fetch(URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formdata)
            });
            
            const responseText = await res.text();
            console.log('Registration response status:', res.status);
            console.log('Registration response:', responseText);
            
            let responseData;
            try {
                responseData = responseText ? JSON.parse(responseText) : {};
            } catch (e) {
                console.log('Failed to parse JSON response, using raw text');
                responseData = { message: responseText };
            }
            
            if (res.ok) {
                setVerificationSent(true);
                // Optionally, show a toast or alert: 'Check your email for a verification link.'
            } else {
                const errorMessage = responseData.message || responseData.error || 'Registration failed. Please try again.';
                alert(errorMessage);
                if (res.status === 400) {
                    console.error('Bad request details:', responseData);
                }
            }
        } catch (err) {
            console.error("Error during registration:", err);
            alert(`Registration failed: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    if (verificationSent) {
        return (
            <div className="signup-left-container">
                <div className="verification-sent">
                    <h1 className="signup-heading">Email Verification Sent</h1>
                    <div className="verification-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                            <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                    </div>
                    <p className="verification-text">
                        We've sent a verification email to <strong>{formdata.email}</strong>
                    </p>
                    <p className="verification-instructions">
                        Please check your email and click on the verification link to complete your registration.
                    </p>
                    <p className="verification-note">
                        If you don't see the email, check your spam folder.
                    </p>
                    <button 
                        className="signup-button"
                        onClick={() => navigate("/signin")}
                    >
                        Go to Login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="signup-left-container">
            <h1 className="signup-heading">Welcome Back</h1>
            <h2 className="signup-title">Create free account</h2>
            <div className="input-fileds-container">
                <label className="signup-label">Full Name </label>
                <input
                    className="signup-input"
                    type="text"
                    name="fullName"
                    value={formdata.fullName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                />
                <label className="signup-label">Email </label>
                <input
                    className="signup-input"
                    type="email"
                    name="email"
                    value={formdata.email}
                    onChange={handleChange}
                    placeholder="name@email.com"
                />
                <label className="signup-label">Mobile Number</label>
                <input
                    className="signup-input"
                    type="text"
                    name="mobile"
                    value={formdata.mobile}
                    onChange={handleChange}
                    placeholder="Enter your mobile number"
                    maxLength={10}
                />
                <label className="signup-label">Create Password</label>
                <input
                    className="signup-input"
                    type="password"
                    name="password"
                    value={formdata.password}
                    onChange={handleChange}
                    placeholder="Password"
                />
                <p className="password-content">Enter at least 6 characters.</p>

                <div className="check">
                    <input
                        type="checkbox"
                        id="Accept_Privacy"
                        name="Privacy"
                        value="Checked"
                        className="input-check"
                    ></input>
                    <p className="check-text">
                        Send me special offers, personalized recommendations, and learning
                        tips.
                    </p>
                </div>
            </div>
            <button 
                className="signup-button" 
                onClick={handleSubmit}
                disabled={loading}
            >
                {loading ? "Processing..." : "Sign Up"}
            </button>
            <p className="privacy">
                By signing up, you agree to our Terms of Use and Privacy Policy.
            </p>

            <h2 className="signup-login-button">
                Already have an account?
                <Link to="/signin">
                    <button> Log in</button>
                </Link>
            </h2>
        </div>
    );
};

export default SignUpForm;
